import {SplitFactory} from "@splitsoftware/splitio"
import {generateGUID} from "./guidHelper";

const scriptHash = {
    development: "i7vvu3k2llcms5s8kmpegsb31r398qraugdk",
    staging: "9hbc9u47thoc7adnvgaqac783iu8o0re9821",
    production: "tq0jj954k8scdrvq8r8eupphtr4igfcgo8fj"
}

export async function getSplitClient() {
    let env = "development"
    if (window.location.hostname.split(".")[1] === "development") env = "development"
    else if (window.location.hostname.split(".")[1] === "staging") env = "staging"
    else if (!window.location.hostname.match(/localhost/)) env = "production"
    const key = scriptHash[env]
    const userId = generateGUID()

    const factory = SplitFactory({
        core: {
            authorizationKey: key,
            key: userId
        }
    })

    return new Promise((resolve, reject) => {
        if (!window.splitIOClient) window.splitIOClient = factory.client()

        if (!window.splitSDKReady)
            window.splitIOClient.on(window.splitIOClient.Event.SDK_READY, () => {
                resolve(window.splitIOClient)
                window.splitSDKReady = true
            })
        else resolve(window.splitIOClient)
    })
}

export default class SplitClient {
    static async funcCaller(treatments, user, opts, func) {
        if (!user) return
        if (!window.splitClientFlagCache) window.splitClientFlagCache = {}

        let splitClient = await getSplitClient()

        return splitClient[func](treatments, {
            email: user.email,
        })
    }

    static async getTreatmentsWithConfig(treatments, user, opts) {
        return this.funcCaller(treatments, user, opts, "getTreatmentsWithConfig")
    }

    static async getTreatments(treatments, user, opts) {
        return this.funcCaller(treatments, user, opts, "getTreatments")
    }

    static async getTreatment(treatment, user, opts) {
        return await this.getTreatments([treatment], user, opts)
    }
}
